import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "popover-content" }
const _hoisted_2 = { class: "popover-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-switch pointer", {deep: $options.deep}]),
    relative: "",
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onChange && $options.onChange(...args)), ["stop"])),
    onMouseleave: _cache[1] || (_cache[1] = $event => ($data.popover_disabled = false))
  }, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "bg" }, null, -1 /* HOISTED */)),
    _createVNode(_component_Popover, {
      trigger: "hover",
      disabled: $data.popover_disabled,
      placement: "top",
      "popper-class": "switch-popover",
      "show-after": 700,
      teleported: false,
      "popper-options": {modifiers: [{name: 'offset', options: { offset: [40, 12] }}]}
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["fast-mode row-vcenter", {enabled: !$options.deep}])
        }, [
          _createVNode(_component_Icon, {
            icon: "zap-fast",
            class: "icon",
            stroke: "#717680",
            "stroke-width": "1",
            width: "1.6rem",
            height: "1.6rem"
          }),
          _cache[4] || (_cache[4] = _createTextVNode(" Fast "))
        ], 2 /* CLASS */)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["mode row-vcenter", {enabled: !$options.deep}])
          }, [
            _createVNode(_component_Icon, {
              icon: "zap-fast",
              class: "icon",
              stroke: "#414651",
              "stroke-width": "1",
              width: "1.6rem",
              height: "1.6rem"
            }),
            _cache[2] || (_cache[2] = _createTextVNode(" Fast "))
          ], 2 /* CLASS */),
          _cache[3] || (_cache[3] = _createTextVNode(" Fast answers to simple questions "))
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["disabled"]),
    _createVNode(_component_Popover, {
      disabled: $data.popover_disabled,
      trigger: "hover",
      placement: "top",
      "popper-class": "switch-popover",
      "show-after": 700,
      teleported: false,
      "popper-options": {modifiers: [{name: 'offset', options: { offset: [-40, 12] }}]}
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["deep-mode row-vcenter", {enabled: $options.deep}])
        }, [
          _createVNode(_component_Icon, {
            icon: "atom-02",
            class: "icon",
            stroke: "#717680",
            "stroke-width": "1",
            width: "1.6rem",
            height: "1.6rem"
          }),
          _cache[7] || (_cache[7] = _createTextVNode(" Deep "))
        ], 2 /* CLASS */)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["mode row-vcenter", {enabled: !$options.deep}])
          }, [
            _createVNode(_component_Icon, {
              icon: "atom-02",
              class: "icon",
              stroke: "#414651",
              "stroke-width": "1",
              width: "1.6rem",
              height: "1.6rem"
            }),
            _cache[5] || (_cache[5] = _createTextVNode(" Deep "))
          ], 2 /* CLASS */),
          _cache[6] || (_cache[6] = _createTextVNode(" Multi-agent deep research "))
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["disabled"])
  ], 34 /* CLASS, NEED_HYDRATION */))
}